import { Icon, theme } from "@mindlercare/ui-web";
import { styled } from "styled-components";
import { Typography } from "components/typography";

// width matches default button width
const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
`;

const ChevronRightIcon = styled(IconContainer)<{ active?: boolean }>`
  fill: ${({ active }) =>
    active ? theme.COLORS.BLACK_GREY : theme.COLORS.GRAY_HIGHLIGHT};
  transform: rotate(180deg);
`;
const CenteredContainer = styled.div`
  display: flex;
  width: fit-content;
`;

const StepIndexContainer = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  width: 22px;
  margin-right: 8px;
  border-radius: 50%;
  background: ${({ active }) =>
    active ? theme.COLORS.BLACK_GREY : theme.COLORS.GRAY_MEDIUM};
`;

interface BreadcrumbProps {
  title: string;
  index: number;
  active?: boolean;
}
const Breadcrumb = ({ title, index, active }: BreadcrumbProps) => {
  return (
    <CenteredContainer>
      <StepIndexContainer active={active}>
        <Typography
          insensitive
          variant="body-x-small"
          color={"WHITE"}
          sx={{ fontWeight: theme.FONT.WEIGHT.BOLD }}
        >
          {index}
        </Typography>
      </StepIndexContainer>
      <Typography
        insensitive
        variant={"body"}
        color={active ? "BLACK_GREY" : "GRAY"}
      >
        {title}
      </Typography>
    </CenteredContainer>
  );
};

type Breadcrumb = {
  title: string;
};

interface ProgressBreadcrumbItem {
  breadcrumb: Breadcrumb;
  index: number;
  activeIndex: number;
}

const ProgressBreadcrumbItem = ({
  breadcrumb,
  index,
  activeIndex,
}: ProgressBreadcrumbItem) => {
  return (
    <>
      {index > 0 && (
        <IconContainer>
          <ChevronRightIcon>
            <Icon.ChevronLeft />
          </ChevronRightIcon>
        </IconContainer>
      )}
      <Breadcrumb
        key={`breadcrumb-item-${breadcrumb.title}`}
        title={breadcrumb.title}
        index={index + 1}
        active={activeIndex == index}
      />
    </>
  );
};

interface ProgressBreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  activeIndex: number;
  enabled?: boolean;
}

export const ProgressBreadcrumbs = ({
  breadcrumbs,
  activeIndex,
  enabled = true,
}: ProgressBreadcrumbsProps) => {
  if (!enabled) {
    return null;
  }

  return (
    <CenteredContainer>
      {breadcrumbs.map((breadcrumb, index) => (
        <ProgressBreadcrumbItem
          key={`progress-breadcrumb-item-${index}`}
          breadcrumb={breadcrumb}
          index={index}
          activeIndex={activeIndex}
        />
      ))}
    </CenteredContainer>
  );
};
